import { autoinject, bindable, customElement } from "aurelia-framework";
import { ProjectDTO, UpdateProjectDTO } from "datatypes/SoramaWebApi";

export interface ViewProject extends ProjectDTO {
    /** Whether the project is favorited by the current user */
    favorited: boolean;
    /** The owner (representative) that created the project */
    owner: string;
    /** The size of the project (in bytes?) */
    size: number;
}

@customElement("project-card")
@autoinject
export class ProjectCard {
    @bindable public project: ViewProject;
    @bindable public showDescription = true;
    @bindable public selected = false;

    @bindable public delete: () => void;
    @bindable public favorite: (favorited: boolean) => void;
    @bindable public update: (nameAndDescription: UpdateProjectDTO) => void;

    constructor() {}

    private isEditing = false;
    private oldName = "";
    private oldDescription = "";

    private edit(e: Event): void {
        e.stopPropagation();
        this.isEditing = !this.isEditing;
        this.oldName = this.project.name;
        this.oldDescription = this.project.description;
    }

    private cancelEdit(e: Event): void {
        e.stopPropagation();
        this.isEditing = false;
        this.project.name = this.oldName;
        this.project.description = this.oldDescription;
    }

    private saveEdit(e: Event): void {
        e.stopPropagation();
        this.isEditing = false;
        this.update({ name: this.project.name, description: this.project.description });
    }

    private toggleFavorite(e: Event): void {
        e.stopPropagation();
        this.favorite(!this.project.favorited);
    }

    private clickedDelete(e: Event): void {
        e.stopPropagation();
        this.delete();
    }
}
